module.exports = __webpack_public_path__ + "static/media/img29.c74d9f5a.jpg";